import { render } from "./ConfigurePlatformModal.vue?vue&type=template&id=488ac33d"
import script from "./ConfigurePlatformModal.vue?vue&type=script&lang=js"
export * from "./ConfigurePlatformModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/modals/ConfigurePlatformModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "488ac33d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('488ac33d', __exports__)) {
    api.reload('488ac33d', __exports__)
  }
  
  module.hot.accept("./ConfigurePlatformModal.vue?vue&type=template&id=488ac33d", () => {
    api.rerender('488ac33d', render)
  })

}


export default __exports__